"use client"

import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
  useEffect,
} from "react"
import classes from "./rate.module.css"

const Star = ({ filled, onClick, onMouseEnter, onMouseLeave }: any) => (
  <span
    onClick={onClick}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    className={filled ? classes.starFilled : classes.star}
  />
)

// 1 - 5
const Rate = forwardRef(
  (
    props: {
      initialRating: number
      disabled: boolean
    },
    ref
  ) => {
    const { initialRating = 0, disabled = false } = props

    const [rating, setRating] = useState(initialRating)

    const [hoverRating, setHoverRating] = useState(undefined)

    useEffect(() => {
      setRating(initialRating)
    }, [initialRating])

    const handleMouseEnter = (index) => {
      if (!disabled) {
        setHoverRating(index + 1)
      }
    }

    const handleMouseLeave = () => {
      setHoverRating(undefined)
    }

    const handleClick = (index) => {
      if (!disabled) {
        setRating(index + 1)
      }
    }

    useImperativeHandle(ref, () => ({
      getRating: () => {
        return rating
      },
    }))

    const displayRating = useMemo(() => {
      return hoverRating !== undefined ? hoverRating : rating
    }, [hoverRating, rating])

    return (
      <div className="flex gap-[5px]">
        {[0, 1, 2, 3, 4].map((index) => {
          const isFilled = displayRating >= index + 1

          // 在只读模式下，检查是否需要半颗星
          const isHalfFilled =
            disabled &&
            displayRating >= index + 0.5 &&
            displayRating < index + 1

          return (
            <span
              key={index}
              className="h-[16px] w-[16px] lg_h-[18px] lg_w-[18px]"
              style={{
                position: "relative",
                display: "inline-block",
                cursor: disabled ? "default" : "pointer",
              }}
            >
              <Star filled={false} />
              <Star
                filled={isFilled}
                onClick={() => handleClick(index)}
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={handleMouseLeave}
              />
              {disabled && isHalfFilled && (
                <span
                  style={{
                    position: "absolute",
                    left: 0,
                    zIndex: 1,
                    width: "50%",
                    height: "100%",
                    overflow: "hidden",
                    pointerEvents: "none",
                  }}
                >
                  <Star filled={true} disabled={disabled} />
                </span>
              )}
            </span>
          )
        })}
      </div>
    )
  }
)

export default Rate
